import React from 'react';
import { Box, Grid,Typography,useMediaQuery } from '@mui/material';
import workFLowImg from '../../assets/landing-page/images/Flow_Medical_Blue_1.png';
import MobileTime from './workflow_mobile';


const Workflow: React.FC = () => {
    const isMobile = useMediaQuery('(max-width:780px)');


    return (
        <>
        <Grid container  sx={{padding:"2% 6%" }} >   
            {!isMobile && (
                <Grid item md={12} sx={{ height:'85%' }}>
                <Box className='workflow' sx={{position:'absolute' , paddingTop:'20px' }}>
                    <Typography variant='h5' sx={{fontSize:"1.2rem"}} className='small_title'>Workflow</Typography>
                    <Typography variant='h4'  sx={{fontSize:"1.6rem"}} className='title'>Our 3D Animation Workflow</Typography>
                </Box>
                <Box    
                    sx={{
                        maxHeight:'85%',
                        display:'block',
                        margin:'0 auto'
                    }}
                    component="img"
                            src={workFLowImg}
                            alt="Workflow"
                />
            </Grid>
            )}   
            {isMobile && (
              <MobileTime />
            )}      
            
        </Grid>
        
        
      
        </>
    );
};

export default Workflow;
